/**
 * SEARCH_TAB_ID is the reserved id of the search pseudo-tab: the tab that is always there, never
 * created and never closed.
 *
 * It is never the id of a co-pilot conversation, which is a UUID the strip mints, so one string
 * comparison tells the two kinds of tab apart: the search panel shows while the active tab's id
 * equals this, and a conversation shows otherwise.
 *
 * Declared here, in a module that imports nothing, because two sides read it and neither may
 * load the other for it: the tab verbs refuse to close this tab without the agent's threads
 * store in their graph, and the store activates it without the handlers in its own.
 */
export const SEARCH_TAB_ID = "search";
